module.exports = __webpack_public_path__ + "1c41c2054afffec102084cee9cdaf5a1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/iphone6-navy.png
// module id = 842
// module chunks = 0